/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-10 17:20:14
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-12-08 10:34:09
 * @FilePath: /unifyxp-v2-store-portal/src/types/common/module.ts
 */
import { ILinkModule } from './linkType';
import { ProductItem } from './product';

export enum EModuleWidth {
  FULL = 'FULL',
  WIDE = 'WIDE',
  NONE = 'NONE',
}

export enum EModuleHeightUnit {
  Pixel = 'Pixel',
  Percentage = 'Percentage',
}

export enum ENewTabLayerType {
  Image = 'Image',
  Poster = 'Poster',
}

export enum EOverflowOption {
  Carousel = 'ConvertToCarousel',
  AnotherLine = 'ShiftToAnotherLine',
  Hide = 'Hide',
}

export enum EPositionOption {
  Left = 'Left',
  Right = 'Right',
  Top = 'Top',
  Bottom = 'Bottom',
  Center = 'Center',
}

export enum EBackgroundType {
  NONE = 'NONE',
  COLOR = 'COLOR',
}

export enum ELayerType {
  BUTTON = 'BUTTON',
  TEXT = 'TEXT',
  IMAGE = 'IMAGE',
  MORE = 'MORE',
}

export enum EResponsiveProductToShow {
  One = 'One',
  Two = 'Two',
  Three = 'Three',
  Four = 'Four',
  Five = 'Five',
  Six = 'Six',
  TwoLandscape = 'TwoLandscape',
  TwoPortrait = 'TwoPortrait',
}

export enum EResponsiveContentPageToShow {
  One = 'One',
  Two = 'Two',
  Three = 'Three',
  Four = 'Four',
  Five = 'Five',
  Six = 'Six',
  TwoLandscape = 'TwoLandscape',
  TwoPortrait = 'TwoPortrait',
}

export enum EResponsiveResizingOption {
  SCALABLE = 'SCALABLE',
  FIXED = 'FIXED',
}

export enum EResponsivePosterType {
  ONE = 'ONE',
  TWO_1_1 = 'TWO_1_1',
  TWO_1_2 = 'TWO_1_2',
  TWO_2_1 = 'TWO_2_1',
  THREE = 'THREE',
  FOUR = 'FOUR',
  FIVE = 'FIVE',
  SIX = 'SIX',
}

export enum EResponsivePosterGap {
  NONE = 'NONE',
  SMALL = 'SMALL',
  MIDDLE = 'MIDDLE',
  LARGE = 'LARGE',
}

export enum EResponsiveCarouselModuleSwitcherType {
  ModuleStyle = 'ModuleStyle',
  Animation = 'Animation',
  Image = 'Image',
  Products = 'Products',
  Text = 'Text',
  ContentPage = 'ContentPage',
  TabStyle = 'TabStyle',
}

export enum EnumScrollType {
  Smooth = 'Smooth',
  Paged = 'Paged',
}

export enum EnumCarouselOptions {
  Two = 'Two',
  One = 'One',
  Three = 'Three',
  Four = 'Four',
  Five = 'Five',
}

export enum EnumModuleType {
  Carousel = 'Carousel',
  ProductCarousel = 'ProductCarousel',
  Poster = 'Poster',
  LongCanvas = 'LongCanvas',
  Text = 'Text',
  ProductGrid = 'ProductGrid',
  ProductList = 'ProductList',
  Edm = 'Edm',
  ProductContentCarousel = 'ProductContentCarousel',
  Subscription = 'Subscription',
  ArticleCarousel = 'ArticleCarousel',
  ArticleList = 'ArticleList',
  Video = 'Video',
  ResponsiveProductCarousel = 'ResponsiveProductCarousel',
  ResponsiveImageCarousel = 'ResponsiveImageCarousel',
  ResponsiveContentCarousel = 'ResponsiveContentCarousel',
  ResponsiveSubscription = 'ResponsiveSubscriptionForm',
  ResponsiveText = 'ResponsiveTextEditor',
  ResponsivePoster = 'ResponsivePoster',
  ResponsiveProductGrid = 'ResponsiveProductGrid',
  ResponsiveContentGrid = 'ResponsiveContentGrid',
  ResponsiveProductTab = 'ResponsiveProductTab',
  ResponsiveContentTab = 'ResponsiveContentTab',
  ResponsivePosterTab = 'ResponsivePosterTab',
  ResponsiveIframe = 'ResponsiveIframe',
}

export enum EnumSeoTag {
  H1 = 'H1',
  H2 = 'H2',
}

export interface ICarouselModule {
  posterType: EnumCarouselOptions;
  autoPlay: boolean;
  intervalTime: number;
  linkModules: ILinkModule;
}
export interface ILongCanvas {
  linkModules: ILinkModule;
}

export interface IPoster {
  posterType: EnumCarouselOptions;
  linkModules: ILinkModule;
}

export interface IProductCarousel {
  scrollType;
  autoPlay: boolean;
  intervalTime: number;
  productToShow: EnumCarouselOptions;
  products: ProductItem[];
}
export interface IProductGrid {
  backgroundColor: string;
  productToShow: EnumCarouselOptions;
  products: ProductItem[];
}
export interface IProductList {
  products: ProductItem[];
}
export interface IText {
  backgroundColor: string;
  textColor: string;
  header: string;
  content: string;
}
